import apiClient from '../utils/apiClient';

export interface UserMetadata {
  user_id: string;
  alias: string;
  sites: string[];
  updated_at?: string;
  updated_by?: string;
  // Installed autofill userscript version last reported to the backend.
  // undefined = never reported; '' = uninstalled; otherwise the version.
  autofill_plugin_version?: string;
}

export const userService = {
  async fetchUserMetadata(): Promise<UserMetadata> {
    const response = await apiClient.get('/api/usermetadata');
    return response.data;
  },

  /** Report the installed autofill version ('' on uninstall). Backend writes only
   * autofill_plugin_version and returns the updated record. */
  async updatePluginVersion(version: string): Promise<UserMetadata> {
    const response = await apiClient.put('/api/usermetadata', {
      autofill_plugin_version: version,
    });
    return response.data;
  },
};
